import { render, staticRenderFns } from "./business-types-provider.vue?vue&type=template&id=47ce5aa6"
import script from "./business-types-provider.vue?vue&type=script&lang=js"
export * from "./business-types-provider.vue?vue&type=script&lang=js"
import style0 from "./business-types-provider.vue?vue&type=style&index=0&id=47ce5aa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports